export class UpdateInboxBadgeCount {
  static readonly type = '[Task-Management] UpdateInboxBadgeCount';
  constructor(public newCount: number) {}
}
